import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center warm-canvas">
        <p className="text-sm text-slate-500">Cargando...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
